import PropTypes from 'prop-types'

const Logo = ({ className = '', size = 'large', style = {} }) => {
  // SVG size mappings (approximate height in pixels) - reduced by 25% total
  const svgSizes = {
    small: 27, // was 36
    medium: 36, // was 48
    large: 45, // was 60
    xlarge: 72, // was 96
  }

  const height = svgSizes[size]
  // Original SVG viewBox is "0 0 150.16 51.3" so aspect ratio is ~2.93
  const width = height * 2.93

  // Merge default styles with custom style prop
  const defaultStyle = {
    height: `${height}px`,
    width: `${width}px`,
  }

  return (
    <img
      src="/media/logo.svg"
      alt="Et Ai"
      className={`transition-transform duration-300 hover:scale-110 ${className}`}
      data-testid="logo"
      style={{ ...defaultStyle, ...style }}
    />
  )
}

Logo.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge']),
  style: PropTypes.object,
}

export default Logo
